import moment from 'moment';
import constants from '../../constants/global-constants';
var getBrowserQueryParams = function (sandbox, _) { return "?preselectAuthMethod=SSO&connectURL=".concat(sandbox.sandboxHashKey, ".").concat(constants.SANDBOX_BOLT_DOMAIN, ":443"); };
export var isExpiringSoon = function (date) {
    return moment.duration(moment(date).diff(moment())).as('seconds') < 12 * 60 * 60;
};
export var hasExpired = function (date) {
    return moment.duration(moment(date).diff(moment())).as('seconds') <= 0;
};
export var getLaunchUrl = function (sandbox, _) { return "https://".concat(sandbox.sandboxHashKey, ".").concat(constants.SANDBOX_DOMAIN, "/browser/").concat(getBrowserQueryParams(sandbox, _)); };
var getSandboxConnectionUrl = function (sandbox, username) { return encodeURIComponent("bolt+s://".concat(username ? username + '@' : '').concat(sandbox.sandboxHashKey, ".").concat(constants.SANDBOX_BOLT_DOMAIN, ":443")); };
var getSandboxUsername = function (sandbox) { return encodeURIComponent(sandbox.username || 'neo4j'); };
var getSandboxPassword = function (sandbox) { return encodeURIComponent(sandbox.password || 'letmein'); };
export var getBloomLaunchUrl = function (sandbox) { return "https://".concat(sandbox.sandboxHashKey, ".").concat(constants.SANDBOX_DOMAIN, "/bloom/").concat(getBrowserQueryParams(sandbox, "")); };
export var getNeulerLaunchUrl = function (sandbox) {
    var url = getSandboxConnectionUrl(sandbox);
    var username = getSandboxUsername(sandbox);
    var password = getSandboxPassword(sandbox);
    return "https://neuler.graphapp.io?url=".concat(url, "&username=").concat(username, "&accessToken=").concat(password);
};
export var getNeodashLaunchUrl = function (sandbox) {
    var username = getSandboxUsername(sandbox);
    var password = getSandboxPassword(sandbox);
    var url = encodeURIComponent("bolt+s://".concat(username, ":").concat(password, "@neo4j:").concat(sandbox.sandboxHashKey, ".").concat(constants.SANDBOX_BOLT_DOMAIN, ":443"));
    return "https://neodash.graphapp.io/?share&type=url&id=".concat(encodeURIComponent(window.location.href), "neodash_settings.json&dashboardDatabase=neo4j&credentials=").concat(url);
};
export var getToolsLaunchUrl = function (sandbox) {
    var connectionUrl = getSandboxConnectionUrl(sandbox);
    var username = getSandboxUsername(sandbox);
    return "https://tools.neo4jlabs.com/?connectionUrl=".concat(connectionUrl, "&username=").concat(username, "&showNeoProducts=true");
};
export var getWorkspaceLaunchUrl = function (sandbox) {
    var username = getSandboxUsername(sandbox);
    var connectUrl = getSandboxConnectionUrl(sandbox, username);
    // TODO - sso_redirect=<idp_id> ... investigate if this will be useful
    return "https://workspace-preview.neo4j.io/workspace/query?connectURL=".concat(connectUrl);
};
